import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  width: 100%;
  height: calc(100vh - 140px);
  padding: 24px 16px;

  display: grid;
  grid-template-rows: 1fr auto;

  overflow-y: auto;
  overflow-x: hidden;

  .message-end {
    height: 0px;
  }

  @media (min-width: 768px) {
    padding: 24px 100px;
  }
`

export const Messages = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 16px;

  align-self: flex-end;
`
